import { render, staticRenderFns } from "./history-event.vue?vue&type=template&id=54d60e9c&scoped=true&"
import script from "./history-event.vue?vue&type=script&lang=js&"
export * from "./history-event.vue?vue&type=script&lang=js&"
import style0 from "./history-event.vue?vue&type=style&index=0&id=54d60e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d60e9c",
  null
  
)

export default component.exports